import { ClientContactType } from '../../../model/client/clientContactType';

export const clientContactTypesWithPhoneNumbers: ClientContactType[] = [
  ClientContactType.Phone,
  ClientContactType.Viber,
  ClientContactType.WhatsApp,
];
